module.exports = __webpack_public_path__ + "img/activation_server.153923b4.svg";